import { InjectionToken } from '@angular/core';

export const VERSION_TOKEN = new InjectionToken<string>('Version');
